<script setup>
const gsapTimeline = useGsapTimeline()
const props = defineProps({
  lottie: Object,
  position: {
    type: Object,
    default: () => {},
  },
  color: String,
  backgroundColor: String,
  scale: {
    type: Number,
    default: null,
  },
  backgroundClass: {
    type: String,
    default: '',
  },
  renderer: {
    type: String,
    default: 'canvas',
  },
})

const backgroundAnimationElement = ref(null)
onMounted(() => {
  if (props.scale !== null) {
    // Center the animation canvas using margins
    backgroundAnimationElement.value.style.marginLeft = `-${(backgroundAnimationElement.value.clientWidth * props.scale - backgroundAnimationElement.value.clientWidth) / 2}px`
    backgroundAnimationElement.value.style.marginTop = `-${(backgroundAnimationElement.value.clientHeight * props.scale - backgroundAnimationElement.value.clientHeight) / 2}px`
    // Match the size of the canvas to the scale
    backgroundAnimationElement.value.style.width = `${backgroundAnimationElement.value.clientWidth * props.scale}px`
    backgroundAnimationElement.value.style.height = `${backgroundAnimationElement.value.clientHeight * props.scale}px`
  }
  if (props.position?.width) {
    backgroundAnimationElement.value.style.width = `${props.position.width}px`
  }
  if (props.position?.height) {
    backgroundAnimationElement.value.style.height = `${props.position.height}px`
  }

  const { playhead, animation, element } = useLottie(backgroundAnimationElement.value, props.lottie, { gsap: { repeat: -1 }, replaceColorAtIndex: { 0: props.color }, renderer: props.renderer })
  gsapTimeline({ name: 'Background Animation' })
    .set(element, { ...props.position, backgroundColor: props.backgroundColor })
    .to(playhead, animation)
})
</script>

<template>
  <div class="relative h-full w-full">
    <slot />
    <div ref="backgroundAnimationElement" class="absolute top-0 left-0 size-full -z-10 will-change-transform" :class="backgroundClass" />
  </div>
</template>
